import { defineStore } from 'pinia';
import { TERMINAL_STATUSES } from 'dashboard/helper/voice';

export const useCallsStore = defineStore('calls', {
  state: () => ({
    calls: [],
  }),

  getters: {
    activeCall: state => state.calls.find(call => call.isActive) || null,
    hasActiveCall: state => state.calls.some(call => call.isActive),
    incomingCalls: state => state.calls.filter(call => !call.isActive),
    hasIncomingCall: state => state.calls.some(call => !call.isActive),
  },

  actions: {
    handleCallStatusChanged({ callSid, status }) {
      if (TERMINAL_STATUSES.includes(status)) {
        this.removeCall(callSid);
      }
    },

    upsertCall(callData) {
      if (!callData?.callSid) return;

      const existingCall = this.calls.find(
        call => call.callSid === callData.callSid
      );

      if (existingCall) {
        this.calls = this.calls.map(call => {
          if (call.callSid !== callData.callSid) {
            return call;
          }

          return {
            ...call,
            ...callData,
            isActive: callData.isActive ?? call.isActive,
          };
        });
        return;
      }

      this.calls.push({
        ...callData,
        isActive: false,
      });
    },

    addCall(callData) {
      this.upsertCall(callData);
    },

    removeCall(callSid) {
      this.calls = this.calls.filter(c => c.callSid !== callSid);
    },

    setCallActive(callSid) {
      this.calls = this.calls.map(call => ({
        ...call,
        isActive: call.callSid === callSid,
      }));
    },

    clearActiveCall() {
      this.calls = this.calls.filter(call => !call.isActive);
    },

    dismissCall(callSid) {
      this.calls = this.calls.filter(call => call.callSid !== callSid);
    },
  },
});
